/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BackendProperties,
    BackendPropertiesFromJSON,
    BackendPropertiesFromJSONTyped,
    BackendPropertiesToJSON,
} from './';

/**
 * 
 * @export
 * @interface Backend
 */
export interface Backend {
    /**
     * 
     * @type {string}
     * @memberof Backend
     */
    name: string;
    /**
     * 
     * @type {BackendProperties}
     * @memberof Backend
     */
    properties: BackendProperties;
}

export function BackendFromJSON(json: any): Backend {
    return BackendFromJSONTyped(json, false);
}

export function BackendFromJSONTyped(json: any, ignoreDiscriminator: boolean): Backend {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'properties': BackendPropertiesFromJSON(json['properties']),
    };
}

export function BackendToJSON(value?: Backend | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'properties': BackendPropertiesToJSON(value.properties),
    };
}


